import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";

import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";

import RenderPrimitiveValues from "./RenderPrimitiveValues";
import { randomColor } from "../../utils/colorRandomize";

const useStyles = makeStyles(() => ({
  wrapper: {
    borderLeft: `2px dashed ${randomColor()}`,
  },
  dFlex: {
    display: "flex",
  },
  icon: {
    padding: 3,
    borderRadius: "unset",
  },
  parentItem: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: 12,
    marginTop: 8,
    marginBottom: 0,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    letterSpacing: "0.00938em",
  },
  shiftLeft: {
    marginLeft: 20,
  },
}));

const RenderNestedValues = ({
  handleChangeData,
  blockTitle,
  item,
}) => {
  const classes = useStyles();
  const [collapseBlock, setCollapseBlock] = useState(false);

  return (
    <div className={classes.wrapper}>
      <div className={classes.dFlex}>
        <IconButton
          className={classes.icon}
          onClick={() => setCollapseBlock(!collapseBlock)}
        >
          {!collapseBlock ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
        </IconButton>
        <p className={classes.parentItem}>{blockTitle} :</p>
      </div>
      <div className={classes.shiftLeft}>
        {!collapseBlock &&
          item.map((element) => {
            const [key, value] = element;

            if (typeof value === "object") {
              const nestedItem = Object.entries(value);
              return (
                <div key={key}>
                  <RenderNestedValues
                    handleChangeData={handleChangeData}
                    blockTitle={key}
                    item={nestedItem}
                  />
                </div>
              );
            } else {
              return (
                <div key={key}>
                  <RenderPrimitiveValues
                    objectId={item[item.length - 1][1]}
                    handleChangeData={handleChangeData}
                    item={element}
                  />
                </div>
              );
            }
          })}
      </div>
    </div>
  );
};

export default RenderNestedValues;
